export default __webpack_public_path__ + "static/media/apple-touch-icon-144x144.536e9509.png";